import React, { FC, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { CopyButton } from "./CopyBtn";
import { DownloadBtn } from "./DownloadBtn";

interface Props {
  group: any;
  url: string;
}

export const EmailChannel: FC<Props> = ({ group, url }) => {
  const formatImage = group.files[0].location.replace(
    ".mp4",
    "_thumbnail_play_icon.png"
  );

  const formatEmailCode = useMemo(
    () => `
    <a href="${url}"><img src="${formatImage}" /></a>
    `,
    [url]
  );

  return (
    <>
      <Typography fontSize={14} marginBottom={1}>
        Copy the code below to replicate a video player in email.
      </Typography>
      {/* code sample block — deliberately dark in both themes, no token role fits */}
      <Box
        padding={2}
        borderRadius={2.25}
        sx={{
          backgroundColor: "#333",
          color: "#ffffff",
          fontWeight: 300,
          lineHeight: "14px",
          fontSize: "12px",
          marginBottom: "20px",
        }}
      >
        <code>{formatEmailCode}</code>
      </Box>
      <CopyButton text="Email Code" value={formatEmailCode} />
      <DownloadBtn text="Image" href={formatImage} />
    </>
  );
};
